import { DurationConverter } from '@colonist/utils';
export const VOTE_PROMPT_AUTO_HIDE_DELAY_MS = DurationConverter.secondsAsMilliseconds(3);
export class VotePromptAutoHideTimer {
    static shouldAutoHide(voteViewState) {
        const isVoter = voteViewState.role == 'voter';
        const hasConfirmedResponse = voteViewState.viewerVoteResponse != 'pending';
        return isVoter && hasConfirmedResponse;
    }
    schedule(voteId, onDismiss) {
        if (this.voteId == voteId && this.timeout != undefined) return;
        this.cancel();
        this.voteId = voteId;
        this.timeout = setTimeout(()=>{
            this.voteId = undefined;
            this.timeout = undefined;
            onDismiss(voteId);
        }, VOTE_PROMPT_AUTO_HIDE_DELAY_MS);
    }
    cancel() {
        if (this.timeout != undefined) clearTimeout(this.timeout);
        this.voteId = undefined;
        this.timeout = undefined;
    }
}
